/* eslint-disable quotes */
type InsuranceVoucherMap = {
  [key: string]: string;
};

export enum VoucherTypes {
  Percentage = 'PERCENTAGE',
  Insurance = 'INSURANCE',
  Delivery = 'DELIVERY',
}

export const insuranceVoucherMap: InsuranceVoucherMap = {
  'insurance.voucher.card.link': 'Find out more about this offer',
  'insurance.voucher.card.apr': 'Representative 44.9% APR variable',
  'insurance.voucher.card.tandc': 'Terms and conditions apply',
};
